import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  content: {
    width: 'calc(100% - 300px)',
    height: 'calc(100vh - 64px)',
    float: 'right',
    overflowY: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      float: 'none',
      position: 'relative',
      overflowY: 'initial',
    },
    '@media print': {
      height: 'inherit',
    },
  },
}));

export default useStyles;
